/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export enum ProjectDataReturnCodes {
  SuccessImported = 0,
  ValidationFailed = 1,
  SuccessExported = 2,
  Error = 3,
  Validate = 4,
  ProjectParamCreated = 5,
  ProjectParamAlreadyExists = 6,
  SharedParamCreated = 7,
  SharedParamAlreadyExists = 8,
  None = 9,
}
